/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_b2c_cartViewProps } from './aaa_b2c_cart';
import { PriceComponent } from '@msdyn365-commerce/components';
import { IImageSettings, Image } from '@msdyn365-commerce/core';
import OrderSummary from './components/order-summary';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Button, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: IAaa_b2c_cartViewProps) => {
    const _renderPrice = (props: any, ring: any): JSX.Element | null => {
        const { context } = props;
        if (ring.price) {
            return (
                <PriceComponent
                    id={'aaa_b2c_cart'}
                    typeName={'aaa_b2c_cart'}
                    data={ring}
                    freePriceText={'free'}
                    originalPriceText={'original price'}
                    currentPriceText={'current price'}
                    context={context}
                />
            );
        }
        return null;
    };
    const rounded = (ringSize?: number) => {
        if (ringSize) {
            return ringSize.toFixed(2);
        }
        return '';
    };
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
        },
        lazyload: true,
        cropFocalRegion: true
    };
    let continueShoppingUrl = props.context.request.url.requestUrl.origin;
    if (props.context.request.sitePath) {
        continueShoppingUrl = continueShoppingUrl + props.context.request.sitePath;
    }
    return (
        <>
            <Button
                href={`${continueShoppingUrl}${props.config.redirectToContinueShoppingUrl}`}
                className='ms-wishlist-items__product-add-button cart-custom-button'
                title={'Continue Shopping'}
            >
                {props.config.continueShoppingButtonText ? props.config.continueShoppingButtonText : 'Continue Shopping'}
            </Button>
            {props.cartItems.length > 0 && !props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    <div className={'col-auto col-sm-auto col-md-7 col-lg-7'}>
                        {props.cartItems.map((cartItem: any, index: number) => {
                            return (
                                <>
                                    <div className={'aaa-cart-left-section'}>
                                        <div className={'col-auto col-sm-auto col-md-4 col-lg-4'}>
                                            <button
                                                className='ms-wishlist-items__product-remove-button'
                                                aria-label={'Remove from Cart'}
                                                onClick={() => props.removeFromCart(cartItem.snapShotId, cartItem.recId)}
                                            />
                                            <Image
                                                requestContext={props.context.actionContext.requestContext}
                                                altText={cartItem.ProductDetails.Name}
                                                className='ms-wishlist-items__product-image'
                                                title={cartItem.ProductDetails.Name}
                                                src={cartItem.ProductDetails.PrimaryImageUrl}
                                                fallBackSrc={cartItem.fallbackImage}
                                                gridSettings={props.context.request.gridSettings!}
                                                imageSettings={defaultImageSettings}
                                                loadFailureBehavior={'empty'}
                                            />
                                        </div>
                                        <div className={'col-auto col-sm-auto col-md-8 col-lg-8 aaa-cart-detail'}>
                                            <div className={'aaa-cart-heading'}>{cartItem.ProductDetails.Name}</div>
                                            {cartItem.rings &&
                                                cartItem.rings.map((ring: any) => {
                                                    return (
                                                        <div className={'aaa-cart-row'} key={ring.ringId}>
                                                            <span className={'aaa-cart-row-column'}>
                                                                <span className={'aaa-cart-row-column-heading'}>{ring.ringName}</span>
                                                                <span className={'aaa-cart-row-column-text'}>{ring.alloy}</span>
                                                            </span>
                                                            <span className={'aaa-cart-row-column'}>
                                                                <span className={'aaa-cart-row-column-heading'}>{'Size'}</span>
                                                                <span className={'aaa-cart-row-column-text'}>
                                                                    Size {ring.sizeLabel} ( &Oslash; {rounded(ring.sizeValue)}mm)
                                                                </span>
                                                            </span>
                                                            <span className={'aaa-cart-row-column'}>
                                                                <span className={'aaa-cart-row-column-heading'}>{'Specification'}</span>
                                                                <span className={'aaa-cart-row-column-text'}>{ring.specifications}</span>
                                                            </span>
                                                            <span className={'aaa-cart-row-column'}>
                                                                <span className={'aaa-cart-row-column-heading'}>{'Price'}</span>
                                                                <span className={'aaa-cart-row-column-text'}>
                                                                    {_renderPrice(props, ring)}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            <div className={'aaa-cart-final-price'}>{_renderPrice(props, cartItem)}</div>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className={'col-auto col-sm-auto col-md-5 col-lg-5 order-summary'}>
                        {props.cartItems.length > 0 && (
                            <OrderSummary
                                cartItems={props.cartItems}
                                context={props.context}
                                cartTotalPrice={props.cartTotalPrice}
                                submitOrder={props.submitOrder}
                            />
                        )}
                        <div>
                            <div className={'aaa-next-step'}>
                                {ArrayExtensions.hasElements(props.slots.nextSteps) ? (
                                    <Node className='aaa_b2c_cart_textBlock'>{props.slots.nextSteps[0]}</Node>
                                ) : null}
                                <span className={'aaa-next-step-stockist'}>Selected Stockist</span>
                                {props.jwellerInfo && (
                                    <span className={'aaa-next-stockist-text'}>
                                        {props.jwellerInfo.B2BCustomerName}
                                        <br />
                                        {props.jwellerInfo.Address}
                                        <br />
                                        {'p. '}
                                        {props.jwellerInfo.Phone}
                                        <br />
                                        {'e. '}
                                        {props.jwellerInfo.Email}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div>
                            {ArrayExtensions.hasElements(props.slots.needHelp) ? (
                                <Node className='aaa_b2c_cart_textBlock'>{props.slots.needHelp[0]}</Node>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : props.cartItems.length === 0 && !props.isLoading ? (
                <div className={'row aaa-cart-wrapper'}>
                    <div className='col-auto col-sm-auto col-md-12 col-lg-12 ms-order-history__empty-message-container'>
                        <p className='ms-order-history__empty-message'>{'You currently do not have any orders to view.'}</p>
                    </div>
                </div>
            ) : (
                <div className={'row aaa-cart-wrapper'}>Loading...</div>
            )}
        </>
    );
};
